module.exports = __webpack_public_path__ + "img/icon-gas-stove.df4bf710.svg";